import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Loader from '../components/common/Loader';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Wraps any route that requires an authenticated admin user.
 *
 * States:
 *   isLoading  → show full-screen spinner (auth still initialising)
 *   !isAuthenticated → redirect to /unauthorized (no valid session at all)
 *   !isAdmin   → redirect to /forbidden (logged-in but not admin role)
 *   otherwise  → render children normally
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isAdmin, isLoading } = useAuth();

  if (isLoading) return <Loader fullScreen />;
  if (!isAuthenticated) return <Navigate to="/unauthorized" replace />;
  if (!isAdmin) return <Navigate to="/forbidden" replace />;

  return <>{children}</>;
};

export default ProtectedRoute;
